import {
  IProfessionHobby,
  IProfessionSkill,
  IProfessionSubject,
  ITutorProfessionCategory,
  ITutorProfessionDetails
} from '@wot/typings';
import { useState } from 'react';
import { ALERT_ICON } from '../../../../assets/icons';
import ProfileIssues from '../../ProfileIssues';
import AddHobby from './Hobby';
import { AddSubject } from './Subject';
import { Button, RadioButton } from '@wot/components';
import { LOADING } from '../../../../assets/animated';

interface Props {
  edit?: boolean;
  profession?: ITutorProfessionDetails<IProfessionSubject | IProfessionHobby | IProfessionSkill>;
  onSave?: (data: ITutorProfessionDetails<IProfessionSubject | IProfessionHobby | IProfessionSkill>) => void;
  onSaveAndNext?: (data: ITutorProfessionDetails<IProfessionSubject | IProfessionHobby | IProfessionSkill>) => void;
  loading?: boolean;
}

export function AddCategory({ edit, profession, onSave, onSaveAndNext, loading }: Props) {
  const [category, setCategory] = useState<'subject' | 'hobby' | 'skill'>(profession?.data.categoryType || 'subject');
  const [categories, setCategories] = useState<
    ITutorProfessionCategory<IProfessionSubject | IProfessionHobby | IProfessionSkill>[]
  >(profession?.data.categories || []);

  const onSubmit = () => {
    onSave &&
      onSave({
        data: {
          categoryType: category,
          categories
        },
        status: profession?.status === 'verified' ? profession.status : 'pending',
        issues: []
      });
  };
  const onSubmitAndNext = () => {
    onSaveAndNext &&
      onSaveAndNext({
        data: {
          categoryType: category,
          categories
        },
        status: profession?.status === 'verified' ? profession.status : 'pending',
        issues: []
      });
  };
  const handleChange = (data: any) => {
    setCategories(data);
  };

  // const onSubmitNext = () => {
  //   onSaveAndNext && onSaveAndNext({
  //     data: educationList,
  //     status: "pending",
  //     issues: []
  //   });
  // }

  return (
    <div className="h-full flex flex-col overflow-hidden">
      <div className="relative w-full h-full md:px-10 flex flex-col">
        {profession?.status === 'issue' && profession.issues.length > 0 && <ProfileIssues issues={profession.issues} />}
        {!edit && (
          <div className="flex flex-col px-2">
            <h2 className="font-medium text-xl">What do you Teach</h2>
            <div className="pt-4 flex lg:flex-row flex-col lg:items-center items-start justify-start gap-2 lg:gap-0">
              <p className="w-40">Category</p>
              <div className="flex flex-row flex-wrap gap-4 md:gap-8 items-center justify-start">
                <RadioButton
                  checked={category === 'subject'}
                  label="Subject"
                  name="select-category"
                  disabled={false}
                  onChange={(x) => x && setCategory('subject')}
                />
                <RadioButton
                  checked={category === 'hobby'}
                  label="Hobby"
                  name="select-category"
                  disabled={false}
                  onChange={(x) => x && setCategory('hobby')}
                />
                <RadioButton
                  checked={category === 'skill'}
                  label="Skill Development"
                  name="select-category"
                  disabled={false}
                  onChange={(x) => x && setCategory('skill')}
                />
              </div>
            </div>
            <div className="flex flex-row items-center lg:ml-40 ml-0 py-3 mb-2">
              <img src={ALERT_ICON} alt="alert" className="h-4 w-4" />
              <p className="text-sm font-medium text-red-600 pl-2">
                {`You are adding a ${category}, you won’t be able to teach any other category.`}
              </p>
            </div>
          </div>
        )}
        <hr />
        {
          category === 'subject' ? (
            <AddSubject
              categories={categories as ITutorProfessionCategory<IProfessionSubject>[]}
              handleChange={handleChange}
            />
          ) : category === 'hobby' || category === 'skill' ? (
            <AddHobby
              category={category}
              categories={profession?.data.categories as ITutorProfessionCategory<IProfessionHobby>[]}
              handleChange={handleChange}
            />
          ) : null
          // <SkillItem />
        }

        {categories.length > 0 && (
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full bg-white py-5 border-t">
            <div className="max-w-sm w-full mx-auto flex gap-4 items-center justify-center">
              {loading ? (
                <div className="w-full flex items-center justify-center">
                  <img src={LOADING} className="w-10 h-10" />
                </div>
              ) : (
                <>
                  <div className="w-full block md:max-w-[164px]">
                    <Button block text={'Save'} onClick={() => onSubmit()} />
                  </div>
                  {onSaveAndNext && (
                    <div className=" max-w-[164px] w-full mx-auto flex gap-4 items-center justify-center">
                      <Button block text={'Submit Form'} onClick={() => onSubmitAndNext()} />
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// function SkillItem() {
//   const [skill, setSkill] = useState("");
//   const [levels, setLevels] = useState<string[]>([]);
//   const [type, setType] = useState<string>("");
//   const [exp, setExp] = useState<number>();
//   const [strengths, setStrengths] = useState<string[]>([]);

//   const {
//     register,
//     control,
//     handleSubmit,
//     formState: { errors },
//   } = useForm();
//   return (
//     <div className="my-4 w-[80%]">
//       <div className="py-3 flex items-center">
//         <p className="w-2/5">Select Skill</p>
//         <DropDown
//           label="Select Skill"
//           value={skill}
//           icon={ARROWDOWN_ICON}
//           name="skill"
//           register={register}
//           errors={errors}
//           required={"Please select a Skill"}
//         >
//           <SearchInDropDown listoptions={hobbyOptions} icon={SEARCH_ICON}>
//             <DropDownItems options={hobbyOptions} setValue={setSkill} />
//           </SearchInDropDown>
//         </DropDown>
//       </div>
//       <div className="py-3 flex items-center">
//         <p className="w-2/5">Type</p>

//         <DropDown
//           label="Type"
//           value={type}
//           icon={ARROWDOWN_ICON}
//           name="type"
//           register={register}
//           errors={errors}
//           required={"Please select a skill type"}
//         >
//           <SearchInDropDown listoptions={typeOptions} icon={SEARCH_ICON}>
//             <DropDownItems options={typeOptions} setValue={setType} />
//           </SearchInDropDown>
//         </DropDown>
//       </div>
//       <div className="py-3 flex items-center justify-start">
//         <p className="w-2/5">Level</p>
//         <DropDownCheckBox label="Level" values={levels} icon={ARROWDOWN_ICON}>
//           <CheckboxGroup
//             options={levelOptions}
//             checkedList={levels}
//             onChange={(list: any) => {
//               setLevels(list);
//             }}
//           />
//         </DropDownCheckBox>
//       </div>
//       <div className="py-3 flex items-center">
//         <p className="w-2/5">Experience</p>
//         <DropDown
//           label="Experience"
//           value={exp ? exp.toString() : ""}
//           icon={ARROWDOWN_ICON}
//           name="experience"
//           register={register}
//           errors={errors}
//           required={"Experience is required"}
//           children={expOptions.map((yr, i) => (
//             <p
//               className="py-2 px-4 hover:bg-neutralBlue1"
//               onClick={() => setExp(yr)}
//             >
//               {yr}
//             </p>
//           ))}
//         />
//       </div>

//       <div className="py-3 flex items-center">
//         <p className="w-2/5">Add Strengths</p>
//         {/* <Strengths icon={CLOSE_ICON} /> */}
//       </div>
//     </div>
//   );
// }

export default AddCategory;
